import React from 'react';

import type { InstagramStoryComponentsProps } from './types';

export function Header(_props: InstagramStoryComponentsProps): React.JSX.Element {
	return <div>Instagram Story Header</div>;
}
